import { useState } from "react";
import Turnstile from "react-turnstile";
import { type SpaceTokens, View } from "tamagui";
import { analyticsService } from "../../../lib/analytics/analytics";
import { useBotControl } from "./BotControlProvider";

// For local testing, special keys to force Turnstile behavior
// https://developers.cloudflare.com/turnstile/tutorials/excluding-turnstile-from-e2e-tests/#overview
// "1x00000000000000000000AA" -> Always passes without challenge
// "2x00000000000000000000AB" -> Always fails
// "3x00000000000000000000FF" -> Always shows interactive challenge
// "1x00000000000000000000BB" -> Invisible, always pass
// "2x00000000000000000000BB" -> Invisible, always fail
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const botControlKey = process.env.NEXT_PUBLIC_BOT_CONTROL_KEY ?? "";
const suppressedErrorPrefixes = ["102",
// Invalid Parameters (retryable)
"103",
// Invalid Parameters (retryable)
"104",
// Invalid Parameters (retryable)
"106",
// Invalid Parameters (retryable)
"11060",
// Challenge timed out (retryable)
"11062",
// Challenge timed out (visible mode, retryable)
"300",
// Generic client execution error (retryable)
"600" // Challenge execution failure (retryable)
];

// https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/
// If an error callback returns with a non-falsy result, Turnstile will
// assume that the error callback handled the error accordingly.
const onBotControlError = (errorCode: string) => {
  analyticsService.trackEvent("BotControlChallengeError", {
    errorCode
  });

  // Suppress default error handling (which would normally throw an error and result in a sentry alert)
  if (suppressedErrorPrefixes.some(prefix => errorCode.startsWith(prefix))) {
    console.warn(`Suppressed bot control error: ${errorCode}`);
    return true;
  }
  console.error(`Bot control turnstile error: ${errorCode}`);
  return false;
};
const onBotControlLoaded = () => {
  analyticsService.trackEvent("BotControlChallengeIssued", {});
};
type BotControlProps = {
  interactiveMargin: SpaceTokens;
};
export const BotControl = ({
  interactiveMargin
}: BotControlProps) => {
  const {
    onBotControlVerified,
    onBotControlExpired,
    isBotControlEnabled
  } = useBotControl();
  const [isInteractive, setIsInteractive] = useState(false);
  if (!isBotControlEnabled) {
    return null;
  }
  return (
    // The turnstile still takes up space even when hidden, so we need to manually hide it with a height of 0
    <View marginBottom={isInteractive ? interactiveMargin : 0} height={isInteractive ? undefined : 0} data-sentry-element="View" data-sentry-component="BotControl" data-sentry-source-file="BotControl.tsx">
      <Turnstile theme="auto"
      // eslint-disable-next-line @medbillai/no-fixed-style-props
      size="flexible" appearance="interaction-only" refreshExpired="auto" sitekey={
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      botControlKey} onBeforeInteractive={() => setIsInteractive(true)} onVerify={onBotControlVerified} onExpire={onBotControlExpired} onError={onBotControlError} onLoad={onBotControlLoaded} data-sentry-element="Turnstile" data-sentry-source-file="BotControl.tsx" />
    </View>
  );
};